export const FETCH_PROJECTS_START = "FETCH_PROJECTS_START";
export const FETCH_PROJECTS_SUCCESS = "FETCH_PROJECTS_SUCCESS";
export const FETCH_PROJECTS_FAILURE = "FETCH_PROJECTS_FAILURE";

export const FETCH_PROJECT_START = "FETCH_PROJECT_START";
export const FETCH_PROJECT_SUCCESS = "FETCH_PROJECT_SUCCESS";
export const FETCH_PROJECT_FAILURE = "FETCH_PROJECT_FAILURE";

export const DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS";
export const DELETE_PROJECT_FAILURE = "DELETE_PROJECT_FAILURE";

export const FETCH_SCENARIOS_START = "FETCH_SCENARIOS_START";
export const FETCH_SCENARIOS_SUCCESS = "FETCH_SCENARIOS_SUCCESS";
export const FETCH_SCENARIOS_FAILURE = "FETCH_SCENARIOS_FAILURE";

export const FETCH_LAYERS_START = "FETCH_LAYERS_START";
export const FETCH_LAYERS_SUCCESS = "FETCH_LAYERS_SUCCESS";
export const FETCH_LAYERS_FAILURE = "FETCH_LAYERS_FAILURE";

export const FETCH_SUBSCRIPTION_START = "FETCH_SUBSCRIPTION_START";
export const FETCH_SUBSCRIPTION_SUCCESS = "FETCH_SUBSCRIPTION_SUCCESS";
export const FETCH_SUBSCRIPTION_FAILURE = "FETCH_SUBSCRIPTION_FAILURE";
export const SET_DEFAULT_PAYMENT_METHOD = "SET_DEFAULT_PAYMENT_METHOD";

// Auth bootstrap (cookie session check)
export const AUTH_BOOTSTRAP_START = "AUTH_BOOTSTRAP_START";
export const AUTH_BOOTSTRAP_SUCCESS = "AUTH_BOOTSTRAP_SUCCESS";
export const AUTH_BOOTSTRAP_FAILURE = "AUTH_BOOTSTRAP_FAILURE";
